<template>
  <div class="container mt-3 pt-5 bg-white">
    <div class="row mt-5">
      <div class="d-sm-none d-md-block col-md-4 mt-5">
        <img src="~../assets/image/pic_calling_man.png" />
      </div>
      <div class="col-sm-4" v-if="!isUpdated">
        <h3 class="text-left pl-3">修改密碼</h3>
        <form class="form-custom pt-0 bg-white">
          <label for="inputOldPassword" class="sr-only">舊密碼</label>
          <input type="password" class="form-control mt-3 rounded" :placeholder="'輸入舊密碼...'" required v-model="old_password">
          <br>
          <label for="inputNewPassword" class="sr-only">新密碼</label>
          <input type="password" class="form-control mt-3 rounded" :placeholder="'輸入新密碼...'" required v-model="new_password">
          <label for="inputNewPassword" class="sr-only">確認新密碼</label>
          <input type="password" class="form-control mt-3 rounded" :placeholder="'再次輸入新密碼...'" required v-model="confirm_new_password">

          <button class="btn btn-success btn-block mt-5" @click.stop.prevent="update()">確定修改</button>
          <button class="btn btn-danger btn-block" @click.stop.prevent="$router.go(-1)">取消修改</button>
        </form>
      </div>
      <div class="col-sm-4" v-else>
        <h3 class="text-left pl-3">恭喜!</h3>
        <form class="form-custom pt-0 bg-white">
          <label class="text-left mt-3" style="line-height: 300%;">您已成功修改您的密碼，請點選下方按鈕，並使用新密碼重新登入。</label>

          <button class="btn btn-success btn-block mt-5" @click.stop.prevent="relogin()">重新登入系統</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {

  name: 'Password',

  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: '',
      isUpdated: false
    }
  },

  methods: {
    ...mapActions([
      'changePassword',
      'logout'
    ]),

    check () {
      if (this.old_password.length === 0) {
        return false
      }

      if (this.new_password !== this.confirm_new_password) {
        return false
      }
    },

    async update () {
      if (!this.check()) {
        console.log('error')
      }

      const { data } = await this.changePassword({
        oldpwd: this.old_password,
        newpwd: this.new_password
      })

      if (data.status === 'OK') {
        this.isUpdated = true
      }
    },

    relogin () {
      this.logout()
        .then(() => {
          this.$router.push('/login')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    letter-spacing: 3px;
  }
</style>


// WEBPACK FOOTER //
// Password.vue?6ab95e4c